import request from "@/util/request.js";
export const getPickList = (sn) =>
  request({
    url: `/shipment/saas/send/pickingList/${sn}`,
    method: "GET",
  });

//app拣货单pdf导出
export const downloadPDF = (params) =>
  request({
    url: "/app/send/pdfDownload",
    method: "GET",
    params,
  });
